import debounce from 'https://cdn.jsdelivr.net/npm/lodash.debounce@4.0.8/+esm';

var settings = {
  scrollOffset: 200,
};

if (document.body.classList.contains('template--index')) {
  settings.scrollOffset = window.innerHeight - 100;
}
if (
  document.body.classList.contains('template--blog-transparency') ||
  document.body.classList.contains('template--article')
) {
  settings.scrollOffset = $('.transparency-hero').height() - 50 || settings.scrollOffset;
}
if (document.body.classList.contains('template--product')) {
  settings.scrollOffset = $('.product-section__img-wrapper').height() - 100;
}

window.addEventListener('DOMContentLoaded', function () {
  window.addEventListener(
    'scroll',
    debounce(
      function () {
        $('body').toggleClass('navbar--scrolled', $(window).scrollTop() > settings.scrollOffset);
        if (document.body.classList.contains('template--index')) {
          $('body').toggleClass('navbar--small-logo', $(window).scrollTop() > 100);
        }
        if ($('.product-section__img-count').length) {
          document.querySelectorAll('.pdp-gallery.lg-hide > picture').forEach(function (el) {
            var countSet = false;
            if (!countSet) {
              if ($(el).offset().top < $(window).scrollTop() + window.innerHeight / 2) {
                $('.product-section__img-count').html(el.getAttribute('data-count'));
                countSet = true;
              }
            }

            // console.log(  )
          });
        }

        if ($('#pdp-hero').length) {
          var stickyOffset = $('#pdp-hero').height() - window.innerHeight / 2;
          if (window.innerWidth < 768) {
            stickyOffset = $('.product-section-block__header-row--buttons').offset().top - 100;
          }
          $('body').toggleClass('product-sticky--show', $(window).scrollTop() > stickyOffset);
        }
        $('body').toggleClass(
          'footer--in-view',
          $(window).scrollTop() > $('.footer__wrapper').offset().top - window.innerHeight
        );
      },
      300,
      { maxWait: 300 }
    ),
    { passive: true }
  );
});
